module.exports = __webpack_public_path__ + "img/10.62c36709.svg";